export const ROUTE_LOGIN = {
    login_url: 'usuario/auth-config',
    login_url2: 'usuario/auth-config'
}

export const ROUTES_ARCHIVOS = {

    titulo_lista_url:'titulo-lista/',
    titulo_lista_url_clases:'clases-genericas/titulo-lista/',
    /********* Administracion***********/
    //TIPO GASTOS
    tipo_gastos_url: 'plan-cuentas/',
    //LIBROS CONTABLESD
    libros_contables_url: 'libros-contables/',
    //PERIODOS CONTABLES
    periodos_contables_url: 'cierre/',
    //PLAN CUENTA
    plan_cuenta_url: 'plan-cuentas/',
    //OPERACIONES:
    tbancos:'tbancos/',
     //CUENTAS POR LIBRO:
    cuentascajachica:'cuenta-caja-chica/',
     //CUENTAS POR LIBRO:
     pcuentasccosto:'plan-cuentas/',
    // TFACTOR
    tfactor:'tfactor/',
    //TREFERENCE
    treference: 'treference/',
    // CENTRO DE COSTOS
    centro_costos_url: 'centro-costos/',
    //SUB CENTRO DE COSTOS
    sub_centro_costos_url: 'subcentro-costos/',
    // TIPO ANALISIS
    tipo_analisis_url: 'tipo-analisis/',
    //Usuario
    usuario_insertar_url: 'usuario/',
    usuario_buscar: 'usuario/buscar?',
    usuario_masivo_buscar: 'usuario/buscar-masivo?',
    usuario_print: 'usuario/print/pdf?',
    usuario_obtener: 'usuario/',
    usuario_actualizar: 'usuario/',
    usuario_eliminar: 'usuario/',
    usuario_auth: 'usuario/auth',
    usuario_cambiar_contra: 'usuario/?/cambiar-clave',
    //Modulos
   modulos_insertar_url: 'modulos/',
   modulos_buscar: 'modulos/buscar?',
   modulos_obtener: 'modulos/',
   modulos_actualizar: 'modulos/',
   modulos_eliminar: 'modulos/',
   modulos_auth: 'modulos/auth',
   modulos_cambiar_contra: 'modulos/?/cambiar-clave',
   //Accesos
   accesos_insertar_url: 'accesos/',
   accesos_buscar: 'accesos/buscar?',
   accesos_obtener: 'accesos/',
   accesos_actualizar: 'accesos/',
   accesos_eliminar: 'accesos/',
   accesos_auth: 'accesos/auth',
   accesos_cambiar_contra: 'accesos/?/cambiar-clave',
    //Compañia
    compañia_insertar_url: 'company/',
    compañia_actualizar_url: 'company/',
    compañia_eliminar_url: 'company/',
    compañia_obtener_url: 'company/',
    compañia_buscar_url: 'company/buscar',

    //Glosa
    glosa_obtener_url: 'company/',
    glosa_eliminar_url: 'company/',

    //Sucursal
    sucursal_buscar_url: 'sucursal/buscar',
    sucursal_insertar_url: 'sucursal/',
    sucursal_actualiza_url: 'sucursal/',
    sucursal_eliminar_url: 'sucursal/',
    sucursal_obtener_url: 'sucursal/',

    //Rol
    rol_obtener_url:'usuario/roles/',

    //PROVEEDOR
    proveedor_buscar_url: 'proveedor/',

    //Clases Sucursal
    clase_sucursal_obtenerclases: 'clases-genericas/sucursal/clases',
    clase_sucursal_eliminarclase: 'sucursal/',
    clase_sucursal_obtener: 'sucursal/',

    //Imagen Sucursal
    imagen_sucursal_insertar: 'sucursal/',
    imagen_sucursal_eliminar: 'sucursal/',
    imagen_sucursal_obtener: 'sucursal/',
    /*********************************/
    //Documentos Cobranza
    documentoscobranza_lista: 'documento-cobranza/consultar',
    documentoscobranza_insertar: 'documento-cobranza/',
    documentoscobranza_eliminar: 'documento-cobranza/',
    documentoscobranza_actualizar: 'documento-cobranza/',
    documentoscobranza_obtener: 'documento-cobranza/',
    documentoscobranza_modalclase: 'documento-cobranza/',

    //Mensual meta
    proymensuales_lista: 'dashboard/cventas-mensual-meta/buscar',
    proymensuales_path: 'dashboard/cventas-mensual-meta',

    //Vendedor meta
    proyvendedor_lista: 'vendedor-meta/buscar',
    proyvendedor_path: 'vendedor-meta',

    //Periodo comision
    periodocomision_lista: 'dashboard/periodo-comision/buscar',
    periodocomision_path: 'dashboard/periodo-comision',

    /*********************************/
    transportista_insertar: 'transportista/',

    //TIPO CAMBIO
    tipo_cambio_insertar_modificar_url: 'tcambio',
    tipo_cambio_buscar: 'tcambio/buscar?',
    tipo_cambio_buscar_hoy: 'tcambio/hoy?',
    tipo_cambio_buscar_rango: 'tcambio/rango?',
    tipo_cambio_importar_sunat: 'tcambio/importar-tipocambio-sunat?',

    //Vendedores
    //obtener_vendedor: 'vendedor/buscar?desven= ',
    obtener_vendedor: 'vendedor/buscar?',
    vendedor_pago_CRUD_url: 'vendedor',
    metas_buscar: 'vendedor-meta/buscar',
    metas_insertar: 'vendedor-meta/',
    metas_actualizar: 'vendedor-meta/',
    metas_eliminar: 'vendedor-meta/{codven}',
    metas_obtener: 'vendedor-meta/{codven}',

    //MONEDA
    moneda_buscar: 'tmoneda/buscar',
    moneda_obtener: 'tmoneda/',
    moneda_insertar: 'tmoneda/',
    moneda_actualizar: 'tmoneda/',
    moneda_eliminar: 'tmoneda/',

    /***** INTERLOCUTOR *****/
    //CONDICION DE PAGO
    condicion_pago_CRUD_url: 'cpago',
    condicion_pago_buscar: 'cpago/buscar?',

    //CONDICION DE PAGO
    cliente_CRUD_url: 'interlocutor',

    /***** LISTA DE PRECIOS *****/
    //CONDICION DE PAGO
    lista_precio_CRUD_url: 'lista-precios',

    //CONDICION DE PAGO
    lista_articulosIsc_CRUD_url: 'articulo-isc',

    /***** UNIDAD MEDIDA *****/
    unidad_medida_CRUD_url: 'unidad',

    /***** TIPO INVENTARIO *****/
    tipo_inventario_CRUD_url: 'tinventario',


    /***** ARTICULO *****/
    //ARTICULO
    articulo_CRUD_url: 'articulo',

    /***** CLASES GENERICAS *****/
    clases_genericas_CRUD_url: 'clases-genericas',

    especificaciones_genericas :'especificaciones-genericas',

  // motivo destino
    motivo_destino_url: 'motivo-destino/',

        //CABECERA
        cabecera_documento: 'clases-genericas/documento-cab',
        cabecera_documento_buscar: 'clases-genericas/documento-cab/buscar',
        cabecera_documento_codigo: 'clases-genericas/documento-cab/codigo',
        cabecera_documento_codigo_buscar: 'clases-genericas/documento-cab/codigo/buscar',
        //CABECERA RANGO
        cabecera_documento_rango: 'clases-genericas/documento-cab-rango',
        cabecera_documento_rango_buscar: 'clases-genericas/documento-cab-rango/buscar',
        cabecera_documento_rango_codigo: 'clases-genericas/documento-cab-rango/codigo',
        cabecera_documento_rango_codigo_buscar: 'clases-genericas/documento-cab-rango/codigo/buscar',
        //DETALLE
        detalle_documento: 'clases-genericas/documento-det',
        detalle_documento_buscar: 'clases-genericas/documento-det/buscar',
        detalle_documento_codigo: 'clases-genericas/documento-det/codigo',
        detalle_documento_codigo_buscar: 'clases-genericas/documento-det/codigo/buscar',
}

export const ROUTE_LOGISTICA = {
    crudReqCompra: 'requerimiento-compra',
    buscarReqCompra: 'requerimiento-compra/buscar',
    calcularReqCompra: 'requerimiento-compra/calcular',

    crudOrdCompra: 'orden-compra',
    buscarOrdCompra: 'orden-compra/buscar',
    calcularOrdCompra: 'orden-compra/calcular',

    crudGuiaInterna: 'guia-interna',
    buscarGuiaInterna: 'guia-interna/buscar',
    calcularGuiaInterna: 'guia-interna/calcular',

    crudTomaInventario: 'toma-inventario',
    buscarTomaInventario: 'toma-inventario/buscar',
    calcularTomaInventario: 'toma-inventario/calcular',

    crudTomaInventarioFisico: 'toma-inventario-fisico',
    buscarTomaInventarioFisico: 'toma-inventario-fisico/buscar',
    calcularTomaInventarioFisico: 'toma-inventario-fisico/calcular',

    crudDocImportacion : 'documento-importacion',
    buscaDocImportacion: 'documento-importacion/buscar',
    calcularDocImportacion: 'documento-importacion/calcular',
}

export const ROUTE_COMERCIAL = {
    /***** RECURSOS *****/
    recursos_url: 'general/recursos/',

    /***** COTIZACION *****/
    crudCotizacion: 'cotizacion',
    buscarCotizacion: 'cotizacion/buscar',
    calcularCotizacion: 'cotizacion/calcular',

    /***** ORDEN DE PEDIDO *****/
    crudOrdenPedido: 'ordenPedido',
    buscarOP: 'ordenPedido/buscar',
    calcularOP: 'ordenPedido/calcular',

    /***** GUIA DE REMISION *****/
    crudGuiaRemision: 'guia-remision',
    buscarGuiaRemision: 'guia-remision/buscar',
    calcularGuiaRemision: 'guia-remision/calcular',

    /***** FACTURA *****/
    crudFactura: 'factura',
    anularFactura: 'factura/anular',
    calcularFactura: 'factura/calcular',

    /***** BOLETA *****/
    crudBoleta: 'boleta',
    calcularBoleta: 'boleta/calcular',

        /***** RECIBO *****/
        crudRecibo: 'recibo',
        calcularRecibo: 'recibo/calcular',


    /************ COMERCIAL **************/
    reportes: 'reportes/comercial/',
    reportes_imprimir: 'reportes/comercial/factura/clientedaot/pdf',
    reportes_daot: 'reportes/comercial/factura/clientedaot/daot'
}

export const ROUTE_INTERLOCUTOR = {
    /***** INTERLOCUTOR *****/
    interlocutor: 'cliente',
    interlocutor_general: 'interlocutor',

}

export const ROUTE_HERRAMIENTAS = {
    /***** INTERLOCUTOR *****/
    reportes: 'report/',
    exportacion: 'exportacionFormato/',
    importacion: 'importaExcel/',
    importacionXML: 'registro-compras/importarXML/'
}

export const ROUTE_LAVANDERIA = {
    crudGuiaRecepcion : 'guiaRecepcion/',
    calcularGuiaRecepcion: 'guiaRecepcion/calcular',
}

export const ROUTE_CONTABILIDAD = {
    reportes: 'reportes/contabilidad/',
    consultas: 'contabilidad/consultas/',
    reporte_balance: 'balanceComprobacion/',
    cpompr_010: 'compr010/',
    registro_compra: 'registro-compras',
    tdocumento: 'tdocume',
    conciliacion: 'conciliacion-bancaria/',
    soporte: 'contabilidad/soporte/',
    reporte_inventario_balance: 'balance/reportes/',
}

export const ROUTE_DECLARACIONESTRIBUTOS = {
    PLE: 'sunat/',

}


export const ROUTE_PLANILLA_CONFIGURACION = {
    cargo: 'cargo',
    estado_civil: 'estado-civil',
    situacion: 'situacion-personal',
    tipo_personal: 'tipotrabajador',
    nacionalidad: 'nacionalidad',
    motivo: 'motivo-planilla',
    tipo: 'tipo',
    tipo_item: 'tipoitem',
    estado_personal: 'estado-personal',
    clase_generica: 'rrhh/clases-genericas',
    clase: 'clase-personal',
    clase_tipo_calculo: 'funcion-planila',
    concepto_pdt: 'conceptos-pdt',
    factores: 'rrhh/factor',
    clase_concepto: 'clase-concepto'
}

export const ROUTE_PLANILLA_PERSONAL = {
    legajo: 'personal-legajo',
    legajo_adjunto: 'personal-legajo-adjuto',
    contrato: 'personal-contratos',
    contrato_adjunto: 'personal-contratos-adjutos'
}
